import { useEffect, useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import SelectDropdown from "../features/header/SelectDropdowns";
import { useAuth } from "../lib/AuthContext";
import useCommonStore from "../store/CommonStore";

export default function UserDropdown() {
    const apiURL = process.env.REACT_APP_API_URL;
    const methods = useForm();
    const [userOptions, setUserOptions] = useState<{ label: string; value: string }[]>([]);

    const { hasAuthenticated } = useAuth();
    const { selectedUser, setSelectedUser } = useCommonStore();

    useEffect(() => {
        const fetchUsers = async () => {
            if (!hasAuthenticated) return;

            try {
                const res = await fetch(`${apiURL}/admin/users?all=true`, {
                    headers: {
                        accept: "application/json",
                        Token: hasAuthenticated,
                    },
                });

                if (!res.ok) throw new Error("Failed to fetch users");

                const data = await res.json();
                const options = data.map((user: any) => ({
                    label: user.username, // show username
                    value: user.id,       // keep id internally
                }));
                setUserOptions(options);
            } catch (err) {
                console.error(err);
            }
        };

        fetchUsers();
    }, [apiURL, hasAuthenticated]);

    return (
        <FormProvider {...methods}>
            <form className="w-full">
                <SelectDropdown
                    label="Filter User"
                    name="filterUser"
                    options={userOptions}
                    defaultValue={selectedUser} // must be string (value)
                    onChange={(value: string) => setSelectedUser(value)}
                    placeHolder="Select user"
                    isAgent={true}
                />
            </form>
        </FormProvider>
    );
}
